import type { useAlbumInterface } from './albumInterfaces'

export default function useAlbum(): useAlbumInterface {
  const getRank = (el: number) => {
    const bronze = '🥉'
    const silverOrGold = el < 2 ? '🥇' : '🥈'
    const icon = el > 2 ? bronze : silverOrGold
    return icon
  }

  return {
    getRank
  }
}
